export default __webpack_public_path__ + "static/media/magGlass.51582e2a.svg";